import i18n from "@/plugins/vue-i18n";

const PasswordChanged = () =>
  import(/* webpackChunkName: "auth" */ "@/views/auth/password-changed/PasswordChangedPage.vue");

const passwordChanged = [
  {
    path: "/auth/password-changed",
    name: "PasswordChanged",
    component: PasswordChanged,
    meta: {
      title: i18n.t("title.yourPasswordHasBeenSuccessfullyChanged"),
    },
  },
];

export default passwordChanged;
